import React from 'react'
import { useSelector } from 'react-redux'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import { ws } from 'src/functions/ws'
import { IState } from '../models/state'

export const GovBrMain = () => {

	const initialPeriod = new Date()
	initialPeriod.setUTCDate(1)
	initialPeriod.setUTCHours(0, 0, 0, 0)

	const finalPeriod = new Date(initialPeriod)
	finalPeriod.setUTCMonth(finalPeriod.getUTCMonth() + 1)
	finalPeriod.setUTCMilliseconds(finalPeriod.getUTCMilliseconds() - 1)

	const [period, setPeriod] = React.useState({
		initialPeriod,
		finalPeriod,
	})

	const report = useSelector((state: IState) => state.govBr)

	React.useEffect(
		() => {
			// ws.send({ type: 'GovBr.GetReport', period } as any)
		},
		[])

	const filterMonthReportPeriod = () => {
		ws.send({ type: 'GovBr.GetReport', period } as any)
	}

	return (
		<div className='orderbooksMain'>
			<span className='pageTitle'>IN 1888</span>
			<Tabs>
				<TabList>
					<Tab>Mensal</Tab>
				</TabList>
				<TabPanel>
					<span className='pageBoxTitle'>Period:</span>
					<div className='filterPeriod'>

						<label htmlFor='initialPeriod' >Initial:</label>
						<input name='initialPeriod' type='date' lang='en-gb' onChange={(e) => setPeriod({ ...period, initialPeriod: new Date(e.target.value + 'T00:00:00.000Z') })} defaultValue={initialPeriod.toJSON().split('T')[0]} />

						<label htmlFor='finalPeriod' >Final:</label>
						<input name='finalPeriod' type='date' pattern='dd/MM/yyyy' onChange={(e) => setPeriod({ ...period, finalPeriod: new Date(e.target.value + 'T23:59:59.999Z') })} defaultValue={finalPeriod.toJSON().split('T')[0]} />

						<button name='filterPeriod' className='walletsTableButton' onClick={filterMonthReportPeriod}>Filter</button>

						<div>
							{report.length
								?
								<a className='walletsTableButton' href={`data:text/plain;base64,${Buffer.from(report.join('\r\n')).toString('base64')}`} download='report.txt'>DOWNLOAD REPORT</a>
								:
								<span>selecione um periodo.</span>
							}
						</div>

					</div>
					<br />
				</TabPanel>
			</Tabs>
		</div>
	)
}


// WEBPACK FOOTER //
// ./src/components/govBrMain.tsx